/* eslint-disable prettier/prettier */
import BotTemplateCard from "@components/Bot-template/bot-template-card";
import NewLayout from "@components/new-ui/Layout";
import { useRouter } from "next/router";
import { FC, useEffect, useRef, useState } from "react";
import { IoTriangleOutline } from "react-icons/io5";
import BrowseByUseCase from "./Bot-template/BrowserByUseCase";
import CtaBlock from "./Bot-template/CTABlock";
import RelatedIndustries from "./Bot-template/RelatedIndustriesBlock";
import TestimonilaBlock from "./Bot-template/TestimonialBlock";
import { BotTemplateCollectionResult, RelatedTemplateData } from "types/wa-chatbot-templates";

interface BotTemplateCollectionsType {
    inputData: BotTemplateCollectionResult;
}

const BotTemplateCollections: FC<BotTemplateCollectionsType> = ({ inputData }) => {
    const _inputData = {
        res: inputData?.res,
        slug: inputData?.slug,
        categories: inputData?.categories || [],
    };
    const [tags, setTags] = useState<string[]>([]);
    const [filteredData, setFilteredData] = useState<any>([]);
    const [isChecked, setIsChecked] = useState<boolean>(false);
    const [currentPage, setCurrentPage] = useState(1);
    const listHeadRef = useRef(null);
    const router = useRouter();
    const { tag: queryTag } = router.query;
    const customTagset = new Set();
    _inputData?.res?.map((e: { tags: any[] }) => e.tags.map((t) => customTagset.add(t.name)));
    const customTags: string[] = [...customTagset] as string[];
    const curentPage = _inputData?.slug[0];
    const industryName = curentPage[0].toUpperCase() + curentPage.slice(1);

    // ------ pagination -----
    const numberOfCards = 9;
    const currentPageData = _inputData?.res?.slice((currentPage - 1) * numberOfCards);
    const totalTemplateLength = _inputData?.res?.length;

    const currentPageFilteredData = filteredData.slice((currentPage - 1) * numberOfCards);
    const totaFilteredlTemplateLength = filteredData?.length;

    function handleNext() {
        if (isChecked) {
            if (currentPage <= totaFilteredlTemplateLength / numberOfCards) setCurrentPage((pre) => pre + 1);
        } else {
            if (currentPage <= totalTemplateLength / numberOfCards) setCurrentPage((pre) => pre + 1);
        }
    }
    function handlePre() {
        if (currentPage > 1) {
            setCurrentPage((pre) => pre - 1);
        }
    }
    const functionSetBg = () => {
        return `https://assets.gallabox.com/gb-home/bot-templates/${industryName}-svg.svg`;
    };

    useEffect(() => {
        if (filteredData?.length >= 1) setIsChecked(true);
        else setIsChecked(false);
    }, [filteredData]);

    const handleCheckbox = (ev: React.ChangeEvent<HTMLInputElement>) => {
        if (queryTag) return;

        const { checked, value } = ev.target;
        const filterTags: string[] = tags;
        if (checked) filterTags.push(value);
        else filterTags.splice(filterTags.indexOf(value), 1);
        setTags(filterTags);

        const filteredDataVal = _inputData?.res?.filter((d: { tags: any[] }) => d.tags.some((t) => filterTags.includes(t.name)));
        setFilteredData(filteredDataVal);
    };

    useEffect(() => {
        if (queryTag) {
            const filteredDataVal = _inputData?.res?.filter((d: { tags: any[] }) => d.tags.some((item) => item.name === queryTag));
            setFilteredData(filteredDataVal);
        } else {
            setIsChecked(false);
        }
    }, [_inputData?.res, queryTag]);

    const handleQueryParam = (tagname: string) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        listHeadRef?.current?.scrollIntoView({ behavior: "smooth" });

        setTimeout(() => {
            router.push({
                pathname: router.pathname,
                query: { tag: tagname },
            });
        }, 1000);
    };

    const giveValidUrl = (name: any) => {
        let validName;
        if (Array.isArray(name)) {
            validName = name.map((each) => {
                return each.split(" ").join("-").toLowerCase();
            });
        } else {
            validName = name.split(" ").join("-").toLowerCase();
        }
        return validName;
    };

    return (
        <NewLayout
            title={
                industryName === "All"
                    ? "Ready-to-use WhatsApp Chatbot Templates | Gallabox"
                    : `Ready-to-use WhatsApp Chatbot Templates for ${industryName.replace("-", " ")} | Gallabox`
            }
            description={
                industryName === "All"
                    ? "Choose from the collection of best WhatsApp Chatbot Templates  and experience it live!"
                    : `Choose from the collection of best WhatsApp Chatbot Templates for ${industryName.replace("-", " ")} and experience it live!`
            }
            canonical={`https://gallabox.com/whatsapp-chatbot-templates${industryName === "All" ? "" : "/" + industryName.toLowerCase()}`}
        >
            <header className="bot-template-collection-header  px-2 md:px-0 py-7  md:py-10   relative flex items-center" style={{ height: "380px" }}>
                <h1 className={`font-bold text-center text-white w-full md:${curentPage !== "all" ? "w-9/12" : "w-8/12"} mx-auto  m-0 lg:96`} style={{ maxWidth: "900px" }}>
                    Ready-to-use <span className="whatsapp-text">WhatsApp </span>
                    Chatbot Templates {curentPage !== "all" ? "for " : ""} {curentPage !== "all" ? <span className="capitalize">{industryName.split("-").join(" ")}</span> : ""}
                </h1>
            </header>
            <p className="text-md md:text-4xl font-bold text-center w-full md:w-full mx-auto pt-7 pb-3 md:pb-10 my-4 md:my-12" style={{ maxWidth: "950px" }}>
                Choose from the collection of best WhatsApp Chatbot Templates for your industry and experience it Live!
            </p>
            <div ref={listHeadRef} className="bot-template-collection lg:w-5/6 mx-auto px-5 lg:px-0 py-10 w-fit" style={{ maxWidth: "1200px" }}>
                <div className="flex flex-col-reverse md:flex-row gap-8 md:gap-0  md:justify-between md:items-center md:pb-7 pt-3">
                    <h2 className="sub-heading m-0">{curentPage === "all" ? "Chatbot" : industryName} Templates</h2>

                    <div className="flex flex-col md:flex-row gap-6 mx-auto w-fit md:mx-0">
                        <div className="dropdown w-fit">
                            <div className="industry-aside-list m-0  flex items-center  justify-between gap-2 text-lg md:text-sm dropbtn md:pl-0">
                                <div className="flex" style={{ columnGap: "14px", maxWidth: "280px" }}>
                                    <img
                                        loading="lazy"
                                        src={`https://assets.gallabox.com/gb-home/bot-templates/industry-icons/${
                                            industryName === "All" ? "Industries" : giveValidUrl(industryName)
                                        }-icon.svg`}
                                        alt="Industries icon"
                                    />
                                    <p className="font-medium flex text-xl capitalize" style={{ columnGap: "14px", color: "#4A5568" }}>
                                        {industryName === "All" ? "Industries" : industryName.replace("-", " ")}
                                    </p>
                                </div>

                                <IoTriangleOutline style={{ fontSize: "9px", color: "#4A5568", transform: "rotate(180deg)" }} />
                            </div>

                            <div className="dropdown-content flex flex-col md:hidden">
                                <a href={"/whatsapp-chatbot-templates/"} className="hover:no-underline text-xl font-normal">
                                    <img loading="lazy" src="https://assets.gallabox.com/gb-home/bot-templates/industry-icons/All-icon.svg" alt="All icon" />
                                    <p style={{ color: "#4A5568" }}>All</p>
                                </a>
                                {giveValidUrl(_inputData?.categories)
                                    .filter((ind: string) => ind !== "all")
                                    ?.map((each: string) => (
                                        <a
                                            href={`/whatsapp-chatbot-templates/${each === "All00" ? "" : each?.toLowerCase()}`}
                                            className="hover:no-underline text-xl font-normal"
                                            key={each}
                                        >
                                            <img loading="lazy" src={`https://assets.gallabox.com/gb-home/bot-templates/industry-icons/${each}-icon.svg`} alt={each + " icon"} />
                                            <p className="capitalize" style={{ color: "#4A5568" }}>
                                                {each.replace("-", " ")}
                                            </p>
                                        </a>
                                    ))}
                            </div>
                        </div>
                        {!queryTag && (
                            <div className="filter-tag">
                                <div className="filter-container flex">
                                    <div className="flex items-center gap-2" style={{ maxWidth: "280px" }}>
                                        <img loading="lazy" src="https://assets.gallabox.com/gb-home/bot-templates/industry-icons/SortTag-icon.svg" alt="Sort icon" />
                                        <p className="font-medium text-xl capitalize w-fit" style={{ columnGap: "14px", color: "#4A5568" }}>
                                            Use Cases
                                        </p>
                                    </div>

                                    <IoTriangleOutline style={{ fontSize: "9px", color: "#4A5568", transform: "rotate(180deg)" }} />
                                </div>
                                <div className="dropdown-content-tag">
                                    {customTags?.map((tagname) => (
                                        <div key={tagname}>
                                            <label className="flex space-between" htmlFor={tagname}>
                                                <div>{tagname}</div>
                                                <div className="check" style={{ marginTop: "6px" }}>
                                                    <input type="checkbox" value={tagname} name={tagname} onChange={(ev) => handleCheckbox(ev)} id={tagname} />
                                                    <span className="geekmark"></span>
                                                </div>
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <main className="w-full  mx-auto mt-4 lg:mt-0">
                    <div className="template-collections ">
                        {(isChecked ? currentPageFilteredData : currentPageData)?.map((each: RelatedTemplateData, i: number) => {
                            if (i < numberOfCards) {
                                return (
                                    <BotTemplateCard
                                        key={each._id}
                                        name={each.title}
                                        id={each._id}
                                        title={each.title}
                                        description={each.description}
                                        count={each.usedCount}
                                        tag={each.tags}
                                        image={each.picture}
                                        category={each.category}
                                    />
                                );
                            }
                        })}
                    </div>
                </main>

                <div className="flex justify-center my-4 lg:my-14 mx-auto">
                    <div className="flex gap-2 place-items-center">
                        <div className="left-arrow grid place-content-center cursor-pointer" onClick={handlePre}>
                            <img loading="lazy" src="https://assets.gallabox.com/gb-home/case-study/small-left-arrow.png" alt="Left Arrow" />
                        </div>
                        <div className="slide-count grid place-content-center">{currentPage}</div>
                        <div className="right-arrow grid place-content-center cursor-pointer" onClick={handleNext}>
                            <img loading="lazy" src="https://assets.gallabox.com/gb-home/case-study/small-right-arrow.png" alt="Right Arrow" />
                        </div>
                    </div>
                </div>
            </div>
            <CtaBlock
                textContent="Automate your customer conversations with Gallabox Chatbot to scale your business."
                img="https://assets.gallabox.com/gb-home/case-study/Robot.png"
            />
            {curentPage !== "all" ? <TestimonilaBlock /> : <RelatedIndustries industryData={_inputData?.categories} />}
            {curentPage === "all" && <BrowseByUseCase handleQuery={handleQueryParam} tagsData={customTags} />}
            <style jsx>
                {`
                    .bot-template-collection-header {
                        background-color: ${curentPage === "all" ? "#0083FF" : "#2D3748"};
                        background-image: url(${curentPage === "all" ? "/pricing-page/pricing-page-patten.svg" : functionSetBg()});
                    }
                    .template-collections {
                        display: grid;
                        gap: 2em;
                    }
                    @media (min-width: 540px) {
                        .template-collections {
                            display: grid;
                            grid-template-columns: repeat(2, 1fr);
                            gap: 1.5em;
                        }
                    }
                    @media (min-width: 790px) {
                        .template-collections {
                            display: grid;
                            grid-template-columns: repeat(3, 1fr);
                            gap: 2em;
                        }
                    }
                `}
            </style>
        </NewLayout>
    );
};

export default BotTemplateCollections;
